import React, { Component } from 'react';
import sortBy from 'lodash/sortBy';

import formatters from '../../formatters';
import ListBars from '../../components/list-bars/list-bars';
import ListSparklines from '../../components/list-sparklines/list-sparklines';
import IconButton from '../../components/icon-button/icon-button';
import DashboardTrendTitle from '../../components/dashboard-trend-title/dashboard-trend-title';
import {
  DashboardColumns,
  DashboardColumnHeader,
  DashboardColumnBody,
} from '../../components/DashboardColumns';

export default class DashboardCommodities extends Component {
  shouldComponentUpdate(nextProps) {
    return (
      nextProps.data !== null &&
      (this.props.data !== nextProps.data || this.props.units !== nextProps.units)
    );
  }

  render(props) {
    if (props.data === null) {
      return <div className="dashboard__grid" />;
    }

    const top = sortBy(props.data.main, [props.units])
      .filter((datum) => {
        return datum[props.units] !== null;
      })
      .reverse()
      .slice(0, 5)
      .map(function (datum) {
        let value = datum[props.units];
        let formatter = props.units === 'value' ? formatters.currency : formatters.weight;

        return {
          label: datum.category.model.name,
          value: value,
          formattedValue: formatter(value),
          disabled: datum.category === props.active,
          original: datum,
        };
      });

    let trendsPropName = `delta_${props.units}_pc`;
    let trends = sortBy(props.data.trends[props.units], [trendsPropName]);
    let trendsMapper = function (datum) {
      let value = datum[trendsPropName];

      return {
        label: datum.category.model.name,
        value: value,
        formattedValue: formatters.signedPercentage(value),
        historicalValues: datum[`agg_${props.units}`],
        disabled: datum.category === props.active,
        original: datum,
      };
    };

    let declining = trends
      .slice(0, 5)
      .filter(function (datum) {
        return datum[trendsPropName] < 0;
      })
      .map(trendsMapper);

    let growing = trends
      .reverse()
      .slice(0, 5)
      .filter(function (datum) {
        return datum[trendsPropName] > 0;
      })
      .map(trendsMapper);

    let button;
    if (props.active && props.active.parent) {
      button = (
        <IconButton
          icon="left"
          title={props.active.parent.model.name}
          handleClick={this.handleButtonClick.bind(this, props.active.parent)}
        >
          Parent
        </IconButton>
      );
    }

    return (
      <DashboardColumns>
        <DashboardColumnHeader modifier="inline">
          <h1>Top 5</h1>
          {button}
        </DashboardColumnHeader>
        <DashboardColumnBody>
          <ListBars data={top} type="commodity" handleClick={props.handleClick} />
        </DashboardColumnBody>
        <DashboardColumnHeader modifier="inline">
          <h1>Fastest growing</h1>
          <DashboardTrendTitle years={props.data.trendYears} />
        </DashboardColumnHeader>
        <DashboardColumnBody>
          <ListSparklines data={growing} type="commodity" handleClick={props.handleClick} />
        </DashboardColumnBody>
        <DashboardColumnHeader modifier="inline">
          <h1>Fastest declining</h1>
          <DashboardTrendTitle years={props.data.trendYears} />
        </DashboardColumnHeader>
        <DashboardColumnBody>
          <ListSparklines data={declining} type="commodity" handleClick={props.handleClick} />
        </DashboardColumnBody>
      </DashboardColumns>
    );
  }

  handleButtonClick = (data) => {
    if (!this.props.handleClick) {
      return;
    }

    this.props.handleClick({ category: data });
  };
}
